import type { Template } from "@/types";

export const PO_04_H4_V0: Template[] = [
{
    id: "hs-04-h4v0-01",
    name: "PO 01 - H4V0",
    albumType: "Hr",
    thumbnail: "/thumbnails/PO/po-04-h4_v0_01.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 162, y: 114, width: 443, height: 308, rotation: 0, imageRotation: 0 },
            { id: "2", x: 162, y: 430, width: 443, height: 307, rotation: 0, imageRotation: 0 },
            { id: "3", x: 612, y: 114, width: 443, height: 308, rotation: 0, imageRotation: 0 },
            { id: "4", x: 612, y: 430, width: 443, height: 307, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h4v0-02",
    name: "PO 02 - H4V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h4_v0_02.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 78, y: 106, width: 454, height: 316, rotation: 0, imageRotation: 0 },
            { id: "2", x: 78, y: 429, width: 454, height: 316, rotation: 0, imageRotation: 0 },
            { id: "3", x: 685, y: 106, width: 454, height: 316, rotation: 0, imageRotation: 0 },
            { id: "4", x: 685, y: 429, width: 454, height: 316, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h4v0-03",
    name: "PO 03 - H4V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h4_v0_03.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 0, y: 309, width: 299, height: 232, rotation: 0, imageRotation: 0 },
            { id: "2", x: 306, y: 309, width: 299, height: 232, rotation: 0, imageRotation: 0 },
            { id: "3", x: 613, y: 309, width: 299, height: 232, rotation: 0, imageRotation: 0 },
            { id: "4", x: 920, y: 309, width: 298, height: 232, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h4v0-04",
    name: "PO 04 - H4V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h4_v0_04.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 0, y: 523, width: 299, height: 232, rotation: 0, imageRotation: 0 },
            { id: "2", x: 306, y: 523, width: 299, height: 232, rotation: 0, imageRotation: 0 },
            { id: "3", x: 613, y: 523, width: 298, height: 232, rotation: 0, imageRotation: 0 },
            { id: "4", x: 919, y: 523, width: 298, height: 232, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h4v0-05",
    name: "PO 05 - H4V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h4_v0_05.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 52, y: 69, width: 507, height: 354, rotation: 0, imageRotation: 0 },
            { id: "2", x: 52, y: 430, width: 507, height: 353, rotation: 0, imageRotation: 0 },
            { id: "3", x: 659, y: 69, width: 507, height: 354, rotation: 0, imageRotation: 0 },
            { id: "4", x: 659, y: 430, width: 507, height: 353, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h4v0-06",
    name: "PO 06 - H4V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h4_v0_06.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 58, y: 72, width: 325, height: 231, rotation: 0, imageRotation: 0 },
            { id: "2", x: 58, y: 311, width: 325, height: 230, rotation: 0, imageRotation: 0 },
            { id: "3", x: 58, y: 549, width: 325, height: 230, rotation: 0, imageRotation: 0 },
            { id: "4", x: 666, y: 253, width: 494, height: 344, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h4v0-07",
    name: "PO 07 - H4V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h4_v0_07.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 61, y: 194, width: 486, height: 465, rotation: 0, imageRotation: 0 },
            { id: "2", x: 666, y: 194, width: 494, height: 314, rotation: 0, imageRotation: 0 },
            { id: "3", x: 666, y: 515, width: 244, height: 143, rotation: 0, imageRotation: 0 },
            { id: "4", x: 917, y: 515, width: 244, height: 143, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h4v0-08",
    name: "PO 08 - H4V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h4_v0_08.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 67, y: 92, width: 306, height: 218, rotation: 0, imageRotation: 0 },
            { id: "2", x: 67, y: 318, width: 306, height: 217, rotation: 0, imageRotation: 0 },
            { id: "3", x: 67, y: 543, width: 306, height: 217, rotation: 0, imageRotation: 0 },
            { id: "4", x: 381, y: 92, width: 769, height: 668, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h4v0-09",
    name: "PO 09 - H4V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h4_v0_09.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 118, y: 158, width: 240, height: 174, rotation: 0, imageRotation: 0 },
            { id: "2", x: 118, y: 339, width: 240, height: 174, rotation: 0, imageRotation: 0 },
            { id: "3", x: 118, y: 521, width: 240, height: 174, rotation: 0, imageRotation: 0 },
            { id: "4", x: 365, y: 158, width: 734, height: 537, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h4v0-10",
    name: "PO 10 - H4V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h4_v0_10.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 31, y: 32, width: 559, height: 390, rotation: 0, imageRotation: 0 },
            { id: "2", x: 31, y: 430, width: 559, height: 390, rotation: 0, imageRotation: 0 },
            { id: "3", x: 628, y: 32, width: 559, height: 390, rotation: 0, imageRotation: 0 },
            { id: "4", x: 628, y: 430, width: 559, height: 390, rotation: 0, imageRotation: 0 }
    ],
}
];